
<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-12">
                <div class="float-right">
                    <button class="dash-btns btn mr-3"[routerLink]="['/PayOut/VirtualAccount']">New
                        Virtual AccountInfo</button>
                     <button class="dash-btns btn mr-3"  [routerLink]="['/PayOut/ManageVirtualAccount']">Manage Virtual AccountInfo </button>
                       
                    <button [routerLink]="['/reports/transactions/summary']" class="dash-btns btn">Reports</button>



                </div>
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-7">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                
                                <div class="text-center">
                                    <a class="view-h gary-t  " > View  Virtual AccountInfo </a>
                                    
                                </div>

                                <div class="pt-3">
                                    <div class=" ">
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>Payout Customerkey Id</label> </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.PayoutCustomerkeyId}}
                                                                             </div>
                                        </div>
                                        <!-- <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>Payout Customerkey Id</label> </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.PayoutCustomerkeyId}}</div>
                                        </div> -->
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>AccountNo</label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.AccountNo}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label> AccountHolderName</label></div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.AccountHolderName}}</div>
                                        </div>
                                      
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>Bank Code/IFSC Code </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.BankCode}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                          <div class="col-4 p-0"> <label>BankCodeType </label>  </div>
                                          
                                          <div class="col-7 p-0 view-text"> {{rows.BankCodeType}}</div>
                                      </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label> Address </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.Address}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label> City </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.City}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label> State</label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot">   {{rows.State }}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>ZipCode</label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.ZipCode}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label> MobileNo </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.MobileNo}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label>  MobileNotification</label> </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.MobileNotification}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label> Email  </label> </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.Email}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label>  EmailNotification </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.EmailNotification}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                          <div class="col-4 p-0"><label>  PayoutProcessor </label>  </div>
                                          
                                          <div class="col-7 p-0 view-text"> {{rows.PayoutProcessor}}</div>
                                      </div>
                                      <div class="row mb-3">
              
                                        <div class="col-4 p-0"><label>  UpdatedDateTime </label>  </div>
                                        
                                        <div class="col-7 p-0 view-text"> {{rows.UpdatedDateTime | date:'d/M/yy, h:mm a'}}</div>
                                    </div>
                                    
                                    <!-- <div class="row mb-3">
              
                                      <div class="col-4 p-0"><label>  UpdatedUserName </label>  </div>
                                      
                                      <div class="col-7 p-0 view-text"> {{rows.UpdatedUserName }}</div>
                                  </div> -->
                                        <div class="row m-1 text-right">
                                           
                                          
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="text-center">
                      <img src="https://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout.png" class="w-100" alt="">
                    </div>
                  </div>
            </div>
        </div>
    </section>
</div>



 